import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { getUserMailboxInfo } from 'owa-client-ids';
import getMailboxByIdentityOperation from 'owa-service/lib/operation/getMailboxByIdentityOperation';
import GetMailboxResponse from 'owa-service/lib/contract/GetMailboxResponse';
import MailboxOptions from 'owa-service/lib/contract/MailboxOptions';

export default function getMailboxForwardingConfigurationService(): Promise<MailboxOptions> {
    return getMailboxByIdentityOperation({
        Header: getJsonRequestHeader(),
        Identity: {
            RawIdentity: getUserMailboxInfo().mailboxId,
        },
    }).then((responseMessage: GetMailboxResponse) => {
        if (responseMessage.WasSuccessful) {
            return responseMessage.MailboxOptions;
        } else {
            throw new Error(
                `getMailboxForwardingConfigurationService ${responseMessage.ErrorCode} ${
                    responseMessage.ErrorMessage
                }`
            );
        }
    });
}
